import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { DataDumpAggregateReportsType } from "../../../../types";

/**
 * Custom uptime calculation for PCI UK
 *
 * @param {DataDumpAggregateReportsType} {
 *   speedGainTime,
 *   producingTime,
 *   speedLossTime,
 *   unplannedTime,
 *   waitingTime,
 *   unknownTime
 * }
 * @return {*} number | null
 */
export const getUptimePercent = ({
  speedGainTime,
  producingTime,
  speedLossTime,
  unplannedTime,
  waitingTime,
  unknownTime,
}: DataDumpAggregateReportsType): number | null => {
  const denom = producingTime + unplannedTime + waitingTime + unknownTime;

  return denom === 0 || isNaN(denom)
    ? null
    : ((speedGainTime + producingTime - speedLossTime) / denom) * 100;
};

/**
 * Custome engineering downtime calculation for PCIUK
 *
 * @param {DataDumpAggregateReportsType} {
 *   unplannedTime,
 *   producingTime,
 *   unknownTime,
 *   waitingTime
 * }
 * @return {*}  {(number | null)}
 */
export const getEngineeringDowntime = ({
  unplanned,
  producing,
  unknown,
  waiting,
}: PnlBreakdown): number | null => {
  const denom =
    producing.durationMs +
    unplanned.durationMs +
    waiting.durationMs +
    unknown.durationMs;

  return denom === 0 || isNaN(denom)
    ? null
    : (unplanned.durationMs / denom) * 100;
};

export const getPciukMetrics = ({
  unplanned,
  waiting,
  operationTime, // production - planned,
}: PnlBreakdown): {
  engineeringDowntime: number | null;
  operationDowntime: number | null;
  valueAddedOpportunity: number | null;
} => {
  // PCIUK omits planned category

  const partOfTheProcess = waiting.tags.find(
    tag => tag.tagName === "Part of the Process"
  );
  const partOfTheProcessDurationMs = partOfTheProcess?.durationMs ?? 0;

  const engineeringDowntime =
    operationTime === 0 || isNaN(operationTime)
      ? null
      : (unplanned.durationMs / operationTime) * 100;

  const operationDowntime =
    operationTime === 0 || isNaN(operationTime)
      ? null
      : ((waiting.durationMs - partOfTheProcessDurationMs) / operationTime) *
        100;

  const valueAddedOpportunity =
    operationTime === 0 || isNaN(operationTime)
      ? null
      : (partOfTheProcessDurationMs / operationTime) * 100;

  return {
    engineeringDowntime,
    operationDowntime,
    valueAddedOpportunity,
  };
};
